export default __webpack_public_path__ + "static/media/upgrade-report2.18e5626b.png";